import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import { deserializeWithMappers, setFieldValues } from 'stores/Utils';
import * as constants from 'Constants';
import * as utils from 'Utils';


class PageStore {

  @setter @observable cartAmount;
  @setter @observable platform;
  @setter @toggle @observable loadedCart;
  @setter @observable onReadyCallback;
  @setter @observable onCartUpdatedCallback;
  @setter @observable formatAmountDisplay;
  @setter @observable aovList;

  constructor() {
    this.reset();
  }

  @action reset() {
    this.cartAmount = 0;
    this.platform = "";
    this.loadedCart = false;
    this.onReadyCallback = null;
    this.onCartUpdatedCallback = null;
    this.formatAmountDisplay = null;
    this.aovList = [];
  }

  getDeserializeMappers() {
    return [
      {"field": "cartAmount", "accessor": "cart_amount"},
      {"field": "platform"},
    ];
  }

  @action async deserialize(data) {
    await deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }

  @action setFields(data) {
    let self = this;
    for (var key in data) {
      let value = data[key];
      self[key] = value;
    }
  }

  @computed get display() {
    if (utils.isProduction() && !this.loadedCart) return false;
    return true;
  }

  @computed get isShopify() {
    return this.platform === "shopify";
  }

  @computed get isBigCommerce() {
    return this.platform === "bigcommerce";
  }

  @computed get isEasyStore() {
    return this.platform === "easystore";
  }

  @computed get isShopline() {
    return this.platform === "shopline";
  }

  @computed get isShopware() {
    return this.platform === "shopware";
  }

  @computed get isWix() {
    return this.platform === "wix";
  }

  @computed get isWooCommerce() {
    return this.platform === "woocommerce";
  }

  @computed get isOtherPlatforms() {
    return this.platform === "others";
  }

  @computed get allReady() {
    return this.aovList.every((aov) => aov.ready);
  }

  @action addAov(aov) {
    this.aovList.push(aov);
  }

  @action removeAov(aov) {
    this.aovList = this.aovList.filter((row) => row.id != aov.id);
  }
}


const pageStore = new PageStore();
export default pageStore;
export { PageStore };
